{
  "schemaVersion": 1,
  "siteKey": "ly",
  "manifestVersion": "ly-c9ff4556baba4e32",
  "resourceKeyHash": "sha256:c9ff4556baba4e32d4e6204691588690e8d33c25ed1121c85d3b0f0fcd5a9af7",
  "itemCount": 2048,
  "completionKind": "answer_submitted"
}
